// 封装http请求
import axios from 'axios';
import qs from 'qs';
import Vue from 'vue';
import util from '@/libs/utils/util';

const http = axios.create({
  baseURL: process.env.VUE_APP_KTV_BASEURL,
  timeout: 15000,
});
http.interceptors.request.use((config) => {
  // 请求头里面加入各种判断
  if (config.method === 'post' && config.data && config.data.constructor !== FormData && !config.headers['Content-Type']) {
    config.data = qs.stringify(config.data);
    config.headers['Content-Type'] = 'application/x-www-form-urlencoded';
  }
  // 接口url中添加BaseUrlType查询字段。如：/login?BaseUrlType=coupon
  // 自动切换http请求的BaseUrl为coupon域名
  if (util.getUrlPrem('BaseUrlType', config.url) === 'other') {
    const index = config.url.indexOf('?');
    config.url = config.url.substring(0, index);
  }
  // 上传图片的域名
  if (util.getUrlPrem('BaseUrlType', config.url) === 'upyun') {
    config.baseURL = process.env.VUE_APP_UPYUN_BASEURL;
  }
  if (util.getUrlPrem('BaseUrlType', config.url) === 'coupons') {
    config.baseURL = 'http://m.ktvsky.com';
  }
  const includeApi = ['/song/reset', '/song/ptoggle', '/song/ctoggle', '/song/control', '/song/mmic', '/song/mvol']; // 显示loading的请求url
  const arr = includeApi.filter((item) => config.url.includes(item));
  const showNormalLoading = !(util.skeletonCheckRoute(location.href, 'ajax') && !arr.length);
  if (!util.getUrlPrem('close_loading', config.url) && showNormalLoading) {
    Vue.$loading.open();
  }
  return config;
}, (error) => {
  // 拦截请求错误
  Promise.reject(error);
});

http.interceptors.response.use((response) => {
  const res = response.data || {};
  Vue.$loading.close();
  if (res.errcode === 200 || res.errcode === 21001 || res.errcode === 0) {
    return res;
  } if (res.code === 200) {
    return res;
  }
  // 根据不同错误码进行提示
  if (res.total) {
    return res;
  }
  if (response.config.url.indexOf('//ad.ktvsky.com/ad/config/') >= 0) {
    return res;
  }
  if (response.config.url.includes('up-z1.qiniup.com')) {
    return res
  }
  Vue.$toast(res.errmsg);
  return Promise.reject(res.errmsg);
}, (error) => {
  // 调用一个错误提醒dialog
  if (axios.isCancel(error)) {
    // console.log('Rquest canceled', error.message) // 请求如果被取消，这里是返回取消的message
  } else {
    // 调用一个错误提醒dialog
    Vue.$toast(error.errmsg);
    Vue.$loading.close();
    return Promise.reject(error);
  }
});

export default http;
